import './identifiers-fields-area.scss'

import { FormApi } from 'final-form'
import Vue from "vue";
import Component from "vue-class-component";

import { ConditionReport, ReportFeatured } from '@skinsoft/types'
import { conditionReportSelectors } from '@skinsoft/selectors';

import { EnhancedTextInput, FieldStatus } from '@skinsoft/ui'
import ThesaurusTermTree from '@skinsoft/ui/src/thesaurus-term-tree'
import { THESAURUS_TERM_SELECTED } from '@skinsoft/ui/src/thesaurus-term-tree/thesaurus-term-tree-modal'

@Component({
    components: {
        sEnhancedTextInput: EnhancedTextInput,
        sThesaurusTermTree: ThesaurusTermTree,
    },
    props: ["reportFeatured", "conditionReport", "form", "fieldName", 'getFieldStatus', 'readOnly'],
    template: require("./identifiers-fields-area.html")
})
export class IdentifierFieldsArea extends Vue {

    public reportFeatured: ReportFeatured;
    public conditionReport: ConditionReport;
    public fieldName: string;
    private readOnly: Boolean

    public form: FormApi;

    private selectedReportReason: string = ''

    public getFieldStatus: (fieldName: string) => FieldStatus

    private THESAURUS_TERM_SELECTED = THESAURUS_TERM_SELECTED

    private mounted() {
        this.selectedReportReason = this.reportFeatured.reportReason
    }

    // getters returning fields name according to data path in condition report object
    public get referenceNumberFieldName() {
        return `${this.fieldName}.conditionReportCS.referenceNumber`
    }

    public get reportReasonFieldName() {
        return `${this.fieldName}.conditionReportCS.reportReason`
    }

    public get precisionsFieldName() {
        return "" // TODO Implement when fields exists in the API
    }

    public get reportTypeFieldName() {
        return `${this.fieldName}.conditionReportCS.reportType`
    }

    private get reportTypeRef(): string {
        return conditionReportSelectors.reportType(this.conditionReport)
    }

    private onReportReasonChanged(thesaurusTermId: string) {
        if(thesaurusTermId) {
            this.form.change('conditionReport.conditionReportCS.reportReason', thesaurusTermId)
            this.selectedReportReason = thesaurusTermId
        }
    }
}